import api, { postForm } from './index'
import { OAUTH_BASIC } from '@/utils/storage'
import { getToken } from '@/utils/storage'

const oauthHeaders = { Authorization: OAUTH_BASIC }

export function login(params) {
  return postForm('oauth/token', {
    username: params.username,
    password: params.password,
    grant_type: 'password',
    imageid: params.captchaId,
    code: params.captcha
  }, oauthHeaders)
}

export function refreshToken(refreshToken) {
  if (!refreshToken) return Promise.resolve()
  return postForm('oauth/token', {
    grant_type: 'refresh_token',
    refresh_token: refreshToken
  }, oauthHeaders)
}

export function logout() {
  // No server-side logout, just a placeholder
  return Promise.resolve()
}

export function getCaptcha() {
  return api.post('f/validation-id')
}

export function me() {
  return api.get('c/me')
}

export function getStatement(id) {
  return api.get('c/statements/' + id)
}

export function acceptStatement(id) {
  return api.post('c/statements/' + id + '/accept')
}

export function getInsInfo() {
  return api.get('c/ins-info')
}

export function updateInsInfo(data) {
  return api.put('c/ins-info', data)
}

export function getIndInfo() {
  return api.get('c/ind-info')
}

export function updateIndInfo(data) {
  return api.put('c/ind-info', data)
}

export function getDocuments(params = {}) {
  return api.get('c/documents', {
    params: { size: 100000, page: 0, sort: 'updateDateTime,desc', ...params }
  })
}

export function getDocumentTypes() {
  return api.get('c/document-types')
}

export function getReports(data) {
  return api.get('c/analysis-reports', {
    params: { ...data, sort: 'updateDateTime,desc', size: 10 }
  })
}

export function getReportTypes() {
  return api.get('c/report-types')
}

export function getAvailableReportTypes(productId) {
  return api.get('c/available-report-types', { params: { productId } })
}

export function getResources(data) {
  return api.get('c/file-resources', {
    params: { ...data, sort: 'updateDateTime,desc', size: 10 }
  })
}

export function getResourceTypes() {
  return api.get('c/resource-types')
}

export function getProducts() {
  return api.get('c/products')
}

export function changePassword(oldPassword, newPassword) {
  return api.post('c/update-password', { oldPassword, newPassword })
}

export function checkActivateToken(id, token) {
  return api.get('f/check-activate-token', { params: { id, token } })
}

export function activateAccount(id, token, password) {
  return api.post('f/activate-account', { id, token, password })
}

export function checkResetPasswordToken(username, token) {
  return api.get('f/check-reset-password-token', { params: { username, token } })
}

export function resetPassword(username, token, password) {
  return api.post('f/reset-password', { username, token, password })
}

export function forgetPassword(params) {
  return api.post('f/forget-password', {
    username: params.username,
    imageid: params.captchaId,
    code: params.captcha
  })
}

export function requestToChangeEmail(newEmail) {
  return api.put('c/request-to-change-email', null, { params: { newEmail } })
}

export function confirmChangeEmail(id, token) {
  return api.put('f/confirm-change-email', null, { params: { id, token } })
}

export function getHistoryNav(id) {
  return api.get('c/product-history-nav/' + id)
}

export function getAllPerformanceIndexes() {
  return api.get('c/product-indexes')
}

// File download URL with token (used for direct browser navigation)
export function getDownloadUrl(documentId) {
  return `${process.env.VUE_APP_API_BASE_URL || '/api/v1'}/c/documents/${documentId}?access_token=${getToken()}`
}

export function getBatchDownloadUrl(ids) {
  return `${process.env.VUE_APP_API_BASE_URL || '/api/v1'}/c/analysis-reports/batch-download?ids=${ids.join(',')}&access_token=${getToken()}`
}

export function getNavDownloadUrl(productId, startDate, endDate) {
  return `${process.env.VUE_APP_API_BASE_URL || '/api/v1'}/c/product-history-nav/${productId}/download?startDate=${startDate}&endDate=${endDate}&access_token=${getToken()}`
}

// Document upload via FormData
export function uploadDocument(formData) {
  return api.post('c/documents', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 客户持仓功能
// Position Rest Controller
// POST/position/exportHoldPosition exportHoldPosition
// GET/position/holdFundList 查询持仓基金列表
// GET/position/queryCustomerIncomeHis 查询产品累计盈亏
// GET/position/queryFundDailyPrice 查询产品业绩走势
// GET/position/queryHoldAccountList 查询持仓账户
// GET/position/queryHoldFundDetail 查询持仓产品详情
// GET/position/queryHoldPositionDetail 查询持仓明细
// GET /position/queryHoldPositionSum 查询持仓汇总
// GET /position/queryTradeHis 查询交易记录列表
// Position details (global, from previous task)
// GET/position/quertHoldFundList 查询持仓基金列表

export function getQueryHoldAccountList(params = {}) {
  return api.get('position/queryHoldAccountList')
}

export function getPositionDetails(params = {}) {
  return api.get('position/queryHoldPositionDetail', {
    params: { ...params, sort: 'positionDate,desc' }
  })
}

export function getQueryHoldPositionSum(params) {
  return api.get('position/queryHoldPositionSum', {
    params: { ...params }
  })
}


// 产品持仓汇总（4宫格数据）
export function getProductPositionSummary(params) {
  return api.get(`position/queryHoldFundDetail`, {
    params: { ...params }
  })
}

// 产品业绩走势（折线图数据） ---- 累计盈亏
export function getProductIncomeHis(params = {}) {
  return api.get(`position/queryCustomerIncomeHis`, { params })
}
// 产品业绩走势（折线图数据） -----业绩走势
export function getProductIncomeHisTwo(params = {}) {
  return api.get(`position/queryFundDailyPrice`, { params })
}
// 产品持仓基金类别列表
export function getProductFundClasses(params = {}) {
  return api.get(`position/quertHoldFundList`, { params: { ...params } })
}

// Product-specific transactions
export function getProductTransactions(params = {}) {
  return api.get(`position/queryTradeHis`, {
    params: { ...params }
  })
}
